import { DefaultButton, Dialog, DialogFooter, PrimaryButton, Spinner } from "office-ui-fabric-react";
import * as React from "react";
import { useState } from "react";
import { searchDeskBookings } from "../../api/bookings";
import { IBookingSearchParams, IMyBooking } from "../../types/Booking.types";

export interface IDeskCheckDialogProps {
    deskId: number;
    onDismiss: (saved: boolean) => void;
    loadBookings?: (deskId: number) => void;
}

export const DeskCheckDialog = (props: IDeskCheckDialogProps) => {
    const [ loading, setLoading ] = useState(true);
    const [ numOfBookings, setNumOfBookings ] = useState<number>(0);

    const checkDeskBookings = async () => {
        let searchParams: IBookingSearchParams = {
            FromDate: new Date().toISOString(),
            DeskId: props.deskId
        };        
        const results = await searchDeskBookings(searchParams);
        if (results.ok) {
            setLoading(false);
            const bookings = await results.json() as IMyBooking[];
            setNumOfBookings(bookings.length);
        }        
    }   

    React.useEffect(() => {
        checkDeskBookings();
    }, []);

    return (
        <Dialog isOpen={true} dialogContentProps={{
            title: "Delete Desk"
        }}>
            { loading === true && (
                <Spinner label="Checking bookings for selected desk..." />
            )}
            { loading === false && numOfBookings > 0 && (
                <div></div>
            )}
            { loading === false && numOfBookings === 0 && (
                <div>There are no future bookings for the desk you are trying to delete. Are you sure you want to continue?</div>
            )}
            { loading === false && numOfBookings > 0 && (
                <div>There are {numOfBookings} future bookings for the desk you are trying to delete. Please click the bookings button below to view these bookings and cancel them if you wish to delete this desk.</div>
            )}            
            <DialogFooter>
                { loading === false && numOfBookings === 0 && (
                    <PrimaryButton label="Delete" iconProps={{iconName: "Delete"}} onClick={() => {
                        props.onDismiss(true);
                    }} />
                )}
                { loading === false && numOfBookings > 0 && (
                    <PrimaryButton label="Load Bookings" text="Load Bookings" iconProps={{iconName: "GroupedList"}} onClick={() => {
                        props.loadBookings ? props.loadBookings(props.deskId) : props.onDismiss(false);
                    }} />
                )}                
                <DefaultButton label="Cancel" iconProps={{iconName: "Cancel"}} onClick={() => {
                    props.onDismiss(false);
                }} />
            </DialogFooter>
        </Dialog>
    )
};
